import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const DocumentsIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 20 20"
        data-fill-none
      >
        <g clipPath="url(#clip0_2822_12591)">
          <path
            d="M4.79688 1.32422H17.5156C17.5156 1.32422 18.6719 1.32422 18.6719 2.48047V15.1992C18.6719 15.1992 18.6719 16.3555 17.5156 16.3555H4.79688C4.79688 16.3555 3.64062 16.3555 3.64062 15.1992V2.48047C3.64062 2.48047 3.64062 1.32422 4.79688 1.32422Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.3594 18.668H2.48438C2.17772 18.668 1.88362 18.5461 1.66678 18.3293C1.44994 18.1125 1.32813 17.8184 1.32812 17.5117V3.63672"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.10938 5.94922H15.2031"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.10938 8.26172H15.2031"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.10938 10.5742H12.8906"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2822_12591">
            <rect
              width="20"
              height="20"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
